import React from "react";
import { Modal, Button } from "antd";
import "./confirmModal.scss"; // Import styles
import { ReactComponent as DeleteSvg } from "../../../assets/images/action/deleteIcon.svg";
import { ReactComponent as DeActivateSvg } from "../../../assets/images/action/deactivateicon.svg";
import { ReactComponent as ActivateSvg } from "../../../assets/images/action/ok.svg";
import { ReactComponent as LogoutSvg } from "../../../assets/images/action/Logout.svg";
import { ReactComponent as DisableSvg } from "../../../assets/images/sidebar/subscription.png";

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  actionType,
  titlePrefix,
  messagePrefix,
}) => {
  const actionConfig = {
    delete: {
      icon: <DeleteSvg className="modal-icon delete-icon" />,
      title: "Delete",
      message: "Are you sure you want to delete this ",
      okText: "Delete",
      okType: "danger",
    },
    activate: {
      icon: <ActivateSvg className="modal-icon activate-icon" />,
      title: "Activate",
      message: "You are going to activate this tenant account.",
      okText: "Activate",
      okType: "primary",
    },
    deactivate: {
      icon: <DeActivateSvg className="modal-icon deactivate-icon" />,
      title: "Deactivate",
      message: "Are you sure you want to deactivate this",
      okText: "Deactivate",
      okType: "primary",
    },
    disable: {
      icon: <DeActivateSvg className="modal-icon deactivate-icon" />,
      title: "Disable",
      message: "Are you sure you want to disable this",
      okText: "Disable",
      okType: "danger",
    },
    enable: {
      icon: <ActivateSvg className="modal-icon activate-icon" />,
      title: "Enable",
      message: "Are you sure you want to enable this",
      okText: "Enable",
      okType: "primary",
    },
    logout: {
      icon: <LogoutSvg className="modal-icon deactivate-icon" />,
      title: "Are you leaving?",
      message: "Are you sure you want to logout ?",
      okText: "YES,LOGOUT",
      okType: "danger",
    },
    // viewProfile: {
    //   icon: <LogoutSvg className="modal-icon deactivate-icon" />,
    //   title: "Are you leaving?",
    //   message: "Are you sure you want to logout ?",
    //   okText: "YES,LOGOUT",
    //   okType: "danger",
    // },
  };

  const { icon, title, message, okText, okType } =
    actionConfig[actionType] || {};

  return (
    <Modal
      centered
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose} className="cancel-btn">
          Cancel
        </Button>,
        <Button
          key="confirm"
          onClick={onConfirm}
          type={okType}
          className="confirm-btn"
        >
          {okText}
        </Button>,
      ]}
      className="custom-confirm-modal"
    >
      <div className="modal-header">
        {icon}
        <h3 className="modal-title">
          {title} {titlePrefix}
        </h3>
      </div>
      <p className="modal-message">
        {message} {messagePrefix}
      </p>
    </Modal>
  );
};

export default ConfirmModal;
